export const roomOptions = [
  { value: 'obyvacka', label: 'Obývacia izba' },
  { value: 'kuchyna', label: 'Kuchyňa' },
  { value: 'spalna', label: 'Spálňa' },
  { value: 'detska', label: 'Detská izba' },
  { value: 'kupelna', label: 'Kúpeľňa a WC' },
]

export const styleOptions = [
  { value: 'minimalisticky', label: 'Minimalistický' },
  { value: 'skandinavsky', label: 'Škandinávsky' },
  { value: 'industrialny', label: 'Industriálny' },
  { value: 'luxusny', label: 'Moderný luxusný' },
  { value: 'boho', label: 'Boho' },
]

export const colorOptions = [
  { id: 'neutral', swatchClass: 'bg-[#E5E5EA]', label: 'Neutrálna' },
  { id: 'warm', swatchClass: 'bg-[#D4B59E]', label: 'Teplá' },
  { id: 'cool', swatchClass: 'bg-[#A8C0D8]', label: 'Studená' },
  { id: 'dark', swatchClass: 'bg-[#2C3E50]', label: 'Tmavá' },
  { id: 'nature', swatchClass: 'bg-[#8F9779]', label: 'Prírodná' },
]

/** Curated "after" shots used only in demo mode (no Gemini API key connected). */
export const demoResults: Record<string, string> = {
  obyvacka: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=900&h=675&fit=crop&crop=center',
  kuchyna: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=900&h=675&fit=crop&crop=center',
  spalna: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=900&h=675&fit=crop&crop=center',
  detska: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=900&h=675&fit=crop&crop=center',
  kupelna: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=900&h=675&fit=crop&crop=center',
}
